import { render, staticRenderFns } from "./ReceiptsFromOikView.vue?vue&type=template&id=59bb4c7c&scoped=true&"
import script from "./ReceiptsFromOikView.vue?vue&type=script&lang=ts&"
export * from "./ReceiptsFromOikView.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptsFromOikView.vue?vue&type=style&index=0&id=59bb4c7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb4c7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
